import Modal from 'react-bootstrap/Modal';
import { useEffect, useState } from 'react';
import PrimaryButton from '../../components/button';
import TextField from '../../components/textFiled';
import ViewCategoriesModal from './ViewCategoriesModal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCreateCategoryMutation } from '../../api';

const STORAGE_KEY_V2 = 'menuCategoriesV2';

type Props = {
  show: boolean;
  hide: () => void;
};

type Category = { id: string; name: string };

function readCategories(): Category[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY_V2);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function saveCategories(cats: Category[]) {
  localStorage.setItem(STORAGE_KEY_V2, JSON.stringify(cats));
}

export default function CreateCategoryModal({ show, hide }: Props) {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [viewList, setViewList] = useState(false);

  useEffect(() => {
    if (show) {
      setName('');
      setError('');
    }
  }, [show]);

  const [createCategory, { isLoading }] = useCreateCategoryMutation();

  const handleAdd = async () => {
    const val = name.trim();
    if (!val) {
      setError('Category name is required');
      return;
    }
    try {
      await createCategory({ name: val }).unwrap();
      toast.success('Category created');
      setName('');
      setTimeout(() => hide(), 900);
    } catch (e: any) {
      const msg = e?.data?.message || 'Failed to create category';
      setError(msg);
      toast.error(msg);
    }
  };

  return (
    <Modal show={show} onHide={hide} centered>
      <Modal.Body>
        <div className='customer-details-title-ctn'>
          <span className='customer-details-title'>Create Category</span>
        </div>
        <div className='modal-details-content'>
          <TextField
            label='Category Name'
            value={name}
            onChange={(e: any) => { setName(e.target.value); setError(''); }}
            required
            type='text'
            placeholder='e.g., Smoothies'
            error={!!error}
            helperText={error}
          />

          <div className='w-full flex justify-end gap-3'>
            <PrimaryButton label={isLoading ? 'Adding...' : 'Add'} onClick={handleAdd} disabled={isLoading} fullWidth={false} />
          </div>
          <div className='w-full flex justify-end mt-2'>
            <PrimaryButton label='View Categories' fullWidth={false} size='small' onClick={() => setViewList(true)} />
          </div>
        </div>
      </Modal.Body>
      <ToastContainer position="top-right" autoClose={2500} hideProgressBar theme="light" />

      {viewList && (
        <ViewCategoriesModal
          show={viewList}
          hide={() => setViewList(false)}
        />
      )}
    </Modal>
  );
}
